var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"custom-btn view-btn",attrs:{"to":_vm.pathUrl}},[_c('img',{attrs:{"src":require("@/assets/images/icons/eye.svg"),"alt":"eye"}})])}
var staticRenderFns = []

export { render, staticRenderFns }